import { useLazyQuery } from '@apollo/client';
import ARE_OPERATIONS_AVAILABLE from '../graphql/queries/are-operations-available';
import { AVAILABILITY_CHECK_ERROR } from '../constants/factoring/operation-unavailability-codes';
import { OPERATION_AVAILABILITY_STATUS as STATUS } from '../constants/factoring/operation-availability-status';

const getOperationAvailabilityStatus = ({ called, loading, error, data }) => {
  if (!called) return STATUS.IDLE;
  if (loading) return STATUS.CHECKING;
  if (error) return STATUS.ERROR;
  const areOperationsAvailable = data?.areOperationsAvailable?.areOperationsAvailable;
  if (areOperationsAvailable === true) return STATUS.AVAILABLE;
  if (areOperationsAvailable === false) return STATUS.BLOCKED;
  return STATUS.ERROR;
};

const useOperationBlockStatus = () => {
  const [
    getAreOperationsAvailable,
    { called, loading, error, data },
  ] = useLazyQuery(ARE_OPERATIONS_AVAILABLE, { fetchPolicy: 'network-only' });

  const status = getOperationAvailabilityStatus({ called, loading, error, data });
  const isBlocked = status === STATUS.BLOCKED || status === STATUS.ERROR;

  let unavailabilityCode;
  if (status === STATUS.ERROR) unavailabilityCode = AVAILABILITY_CHECK_ERROR;
  if (status === STATUS.BLOCKED) {
    unavailabilityCode = data?.areOperationsAvailable?.unavailabilityCode;
  }

  return {
    status,
    isBlocked,
    unavailabilityCode,
    getAreOperationsAvailable,
  };
};

export default useOperationBlockStatus;
